import styled from 'styled-components';

export const UploadList = styled.div`
  color: black;
  width: 200px;
`;
